/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export enum InlandWaterwaysEmissionStandard {
    Conv19702002UsTier1 = 'Conv_1970_2002_USTier1',
    Ccnr120022006 = 'CCNR1_2002_2006',
    Ccnr2Eu3AUsTier22006 = 'CCNR2_EU3A_USTier2_2006',
    EpaTier3 = 'EPATier3',
    EpaTier4 = 'EPATier4',
    EuVGt2019 = 'EU_V_GT2019'
}



